module.exports = __webpack_public_path__ + "images/emoji/laughing.b6104822e96c457e0eee.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/laughing.png
// module id = COlM
// module chunks = 14